import { useTheme } from '@/hooks/useTheme';
import { DEFAULT_PLACEHOLDER_SVG } from '@/constants/placeholder';

/**
 * Returns the branding placeholder image URL, falling back to default SVG.
 * Use this wherever you need a fallback image for broken/missing images.
 */
export const usePlaceholderImage = (): string => {
  const { branding } = useTheme();
  return branding?.assets?.placeholder || DEFAULT_PLACEHOLDER_SVG;
};
